import React from 'react'
import Navbar from '../components/Navbar'
import BlogHeader from '../components/Blog/BlogHeader'
import BlogeMeed from '../components/Blog/BlogeMeed'
import Footer from '../components/Footer'
const Blog = () => {
  return (
    <div>
    <Navbar />
    <BlogHeader />
    <BlogeMeed />
    <Footer/>

    </div>
  )
}

export default Blog
